/**
 * DECK SWITCHES — a composer's on/off CHOICES on the CommandDeck's LOWER deck (left), each a labelled sliding switch
 * (``role="switch"``). Same option shape as ``DeckActions`` ({id, label, short?, icon?, checked, disabled?, reason?,
 * onToggle}); one that doesn't apply right now is GREYED with the reason as its tooltip — never hidden.
 */
import React from 'react';

export default function DeckSwitches({ options = [], testId = 'deck-switches' }) {
  const items = (Array.isArray(options) ? options : []).filter(Boolean);
  if (!items.length) return null;
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-3" data-testid={testId} role="group" aria-label="Build choices">
      {items.map((o) => {
        const on = !!o.checked;
        const Icon = o.icon;
        return (
          <label key={o.id} title={o.disabled ? (o.reason || o.label) : o.label}
            className={`inline-flex select-none items-center gap-1.5 text-[12px] ${o.disabled ? 'cursor-not-allowed opacity-40' : 'cursor-pointer text-gray-700'}`}>
            <button
              type="button"
              role="switch"
              aria-checked={on}
              aria-label={o.label}
              disabled={!!o.disabled}
              data-testid={`${testId}-${o.id}`}
              onClick={() => o.onToggle?.()}
              className={`relative inline-flex h-4 w-8 shrink-0 items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 ${
                on ? 'bg-indigo-600' : 'bg-gray-300'}`}
            >
              <span aria-hidden className={`inline-block h-3 w-3 rounded-full bg-white shadow transition-transform ${on ? 'translate-x-4' : 'translate-x-0.5'}`} />
            </button>
            {Icon ? <Icon className="h-3.5 w-3.5 shrink-0 text-gray-500" aria-hidden /> : null}
            <span className="whitespace-nowrap">{o.short || o.label}</span>
          </label>
        );
      })}
    </div>
  );
}
